// Zacatek kontroly vyher
import {
	madnes_add_img, madnes_get_cstm_val,
	madnes_key_exist, madnes_set_alpha,
	madnes_set_cstm_val, madnes_set_scale,
	madnes_set_visible, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {
	server_config,
	server_result,
	picture_convert,
	set_inanim,
	in_free_spins,
	states, set_rotated, wi, he, set_inwincount, set_in_free_spins, set_server_result
} from "../framework/src/engine/madnes/madnes_variables";

import * as MV from "../framework/src/engine/madnes/madnes_variables";

import {
	madnes_add_win,
	madnes_end_freespins, madnes_end_round, madnes_set_win,
	madnes_start_freespins,
	madnes_win_anim_reset,
	madnes_win_anim_skip, win
} from "../framework/src/engine/madnes/madnes";
import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {freespin_hide, freespin_show} from "./j27_anims";
import {rotate_run} from "./j27_core";
import {ctrl_end_round_freespins, money_add_control} from "./j27_end_ctrl";
import {STATES} from "../framework/src/states/states";
import {cylinder_pos} from "./j27_config";
import {AnimBlink, AnimFade, AnimPulse, AnimScale} from "./j27_extanims";
import AddResult from "../framework/src/connect/result/AddResult";
import {set_result_lock} from "./j27_core_printer";

var result_control_pos = 0;
var spin_win = 0;
export function result_control()
{
	// console.timeEnd('rotate');

	spin_win = 0;

	set_inanim(1); // inanim = 1;
	result_control_pos = 0;

	result_control_part();
}

// kontrola vyhry na aktualni pozici
async function result_control_part()
{
	var lw = server_result['result']['lineWins'];

	if(lw == null || lw[result_control_pos] == null)
	{
		madnes_win_anim_reset();

		if(in_free_spins)
		{
			setTimeout(function() {
				control_freespins(false);
			}, 100);
		}
		else
		{
			money_add_control();
		}

		if(lw != null)
		{
			set_inwincount(false); //inwincount = false;
		}
	}
	else
	{
		states.setState(STATES.SKIP);
		// madnes_hide_stop();

		if(lw[result_control_pos]['type'] == 'freeSpins') {
			madnes_win_anim_reset();
		}

		if(madnes_win_anim_skip()) {
			//if(
			//	server_result.result.lineWins[result_control_pos].type == "normal"
			//) {
				if(typeof lw[result_control_pos]['win'] != "undefined" && server_result.result.lineWins[result_control_pos]['type'] != "full")
				{
					await result_control_proc_add_win(lw[result_control_pos]);
				}

				result_control_pos++;
				result_control_part();
			//} else {
			//	result_control_part_proc(server_result.result.lineWins[result_control_pos]);
			//}
		} else {
			var fli = get_full_line_win_index();
			result_control_proc(lw[result_control_pos], result_control_pos, fli);
		}
	}
}

function get_full_line_win_index()
{
	for(var lineI in server_result.result.lineWins) {
		if(typeof server_result.result.lineWins[lineI] != 'undefined' && server_result.result.lineWins[lineI].type == "full") {
			return lineI;
		}
	}

	return -1;
}

let fsCurrent = 0;
let fsTotal = 0;
let fsAdd = 0;

// kontrola aktualni vyhry
var fireQs = [];
var hidedSprites = [];
function result_control_proc(win_set, actual_index, full_line_index)
{
	set_inwincount(true); //inwincount = true;
	var linenum = 0;

	if(typeof win_set['line'] != "undefined" && win_set['line'] != null && win_set['line'] >= 0)
	{
		linenum = 1;
	}

	if(linenum != 0)
	{
		// madnes_win_anim_add();

		/**
		 * v resultu je fullwin -> vlozit pred vsechny animace animaci win_x2
		 */
		if(full_line_index >= 0 && actual_index == 0) {
			animate_winx2(result_control_proc_anim.bind(this, win_set));
		} else {
			result_control_proc_anim(win_set);
		}

	} else if(typeof win_set['type'] !== 'undefined' && win_set['type'] === 'full') {

		/**
		 * full win_x2 animace jiz byla spustena, preskakujeme
		 */
		result_control_next();

	} else if(win_set['type'] == "freeSpins") {

		madnes_start_freespins();

		set_inwincount(false); //inwincount = false;

		fsCurrent = MV.freespins.getFreeSpinNumber();
		MV.game.freespins.run(new AddResult(server_result));
		fsTotal = MV.freespins.getFreeSpinNumber();
		fsAdd = 0;

		if(!in_free_spins)
		{
			set_in_free_spins(true); // in_free_spins = true;
			// in_free_spins_pos = 0;

			madnes_audio_play('FS_START');
		}

		add_free_spins().then(function() {
			madnes_audio_loop('FS_BG');
			setTimeout(control_freespins, 1000);
		});
		return;

	} else {
		result_control_next();
	}
}

function animate_winx2(callback)
{
	var anims = [];
	var names = [];

	madnes_audio_play('WIN_X2');

	for(var i = 0, l = cylinder_pos.length; i < l; i++) {
		for(var y = 0; y < 3; y++) {
			var symbName = "reels_bufer_" + i + "_S" + y;

//			set_symbol_center(symbName);

			names.push(symbName);
			anims.push(new AnimPulse(symbName, 1.12, 1.12, 180, 100).run());
		}
	}

	Promise.all(anims).then(function() {

		show_win_x2();

		var blink = new AnimBlink(names, 5, 4000);
		blink.run().then(function() {

			madnes_set_visible('win_x2', false);

//			for(var i = 0, len = names.length; i < len; i++) {
//				set_symbol_center_top_left(names[i]);
//			}

			setTimeout(callback, 200);
		});
	});
}

function show_win_x2() {
	if(madnes_key_exist('win_x2')) {
		madnes_set_visible('win_x2', true);
	} else {
		madnes_add_img('win_x2', 'win_x2', wi / 2, he / 2, 1, 0.5, 0.5);
	}
}

//function set_symbol_center(symbName)
//{
////	madnes_set_img_center(symbName, 0.5, 0.5);
////	madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) + madnes_get_dimension_wi(symbName) / 2);
////	madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) + madnes_get_dimension_he(symbName) / 2);
//}
//
//function set_symbol_center_top_left(symbName)
//{
////	madnes_set_img_center(symbName, 0.5, 0);
////	madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) - madnes_get_dimension_wi(symbName) / 2);
////	madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) - madnes_get_dimension_he(symbName) / 2);
//}


function result_control_next()
{
	result_control_pos++;
	result_control_part();
}

// Vstup do freespinu + animace pridani spinu

function add_free_spins()
{
	return new Promise(function(res) {
		add_free_spins_loop(res);
	});
}

function add_free_spins_loop(callback)
{
	madnes_set_visible("bonus_cover", true);
	madnes_set_visible("text_bonus_games_num", true);

	if((fsAdd + fsCurrent) != fsTotal /*in_free_spins_total*1 != server_result['result']['freeSpinNumber']*/)
	{
		fsAdd++;

		madnes_audio_play("bonus_count");

		madnes_audio_play("Btn_bet_mi");
		// in_free_spins_total++;

		if(in_free_spins)
		{
			madnes_set_text("text_bonus_games_num", MV.freespins.getRoundNumber() + "/" + (fsCurrent + fsAdd));
		}
		else
		{
			madnes_set_text("text_bonus_games_num", "0/0");
		}

		setTimeout(add_free_spins_loop.bind(null, callback), 220);
		return;
	}

	if(MV.game.freespins.isSkipping()) {
		madnes_set_win(MV.game.freespins.getResultWin());
	}

	setTimeout(callback, 100);
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

/**
 * @param {boolean=} fsSkipping
 */
async function control_freespins(fsSkipping)
{
	let pos = MV.game.freespins.getRoundIndex() + 1;

	var fsResults = server_result['result']['freeSpinResults'];

	spin_win = 0;

	if(fsResults[pos] == null || typeof fsResults[pos] == "undefined")
	{
		madnes_end_freespins();

		set_in_free_spins(false); // in_free_spins = false;
		// in_free_spins_pos = 0;
		// in_free_spins_total = 0;

		freespin_hide();
		madnes_audio_stop('FS_BG');

		ctrl_end_round_freespins();

	} else {

		// deep copy server result
		let server_result_tmp = JSON.parse(JSON.stringify(server_result));

		set_result_lock(1); // result_lock = 1;
		freespin_show();

		set_rotated(0); // rotated = 0;

		let num = MV.game.freespins.getFreeSpinNumber();

		await madnes_end_round();
		madnes_set_text("text_bonus_games_num", (pos + 1) + "/" + num);

		setTimeout(() => {

			set_server_result(server_result_tmp);

			server_result.result.freeSpinNumber = fsResults[pos]['result']['freeSpinNumber'];
			server_result.result.lineWins = fsResults[pos]['result']['lineWins'];
			server_result.result.gameSpecifics = fsResults[pos]['result']['gameSpecifics'];
			server_result.result.reelMatrix = fsResults[pos]['result']['reelMatrix'];
			set_result_lock(0); //result_lock = 0;
		}, 500);
	}
}

async function result_control_proc_add_win(win_set)
{
	if(!win_set['win']) {
		return;
	}

	await madnes_add_win(win_set['win'] * 1); // win = win * 1 + win_set['win'] * 1;
	spin_win = spin_win * 1 + win_set['win'] * 1;
}

function result_control_proc_anim(win_set)
{
	result_control_proc_add_win(win_set);

	result_control_pos++;

	var jokers = [];
	var symbNames = [];

	for(var pos in win_set['position']) {

		var posit = win_set['position'][pos];

		var xPos = posit[0];
		var yPos = posit[1];
		var yPosS = 2 - yPos;
		var symbName = "reels_bufer_" + xPos + "_S" + yPosS;
		symbNames.push(symbName);

		madnes_set_cstm_val(symbName, get_symbol_on_position(xPos, yPos));

//		set_symbol_center(symbName);
		var symIndex = server_result['result']['reelMatrix'][0][xPos][yPos];
		var symName = server_config['logic']['symbols'][symIndex]['name'];
		if(symName == 'symbol_Joker') {
			jokers.push(symbName);
		}
	}

	new Promise(function(res) {

		setTimeout(res, 100);

	}).then(function() {

		if(typeof win_set['line'] !== 'undefined') {
			show_winline(win_set['line']);
		}

		var anims = [];

		for(var i = 0; i < jokers.length; i++) {
			var scale = new AnimScale(jokers[i], 1.12, 1.12, 200, 0);
            anims.push(scale.run());
		}

		madnes_audio_play("joker_blend");

		return Promise.all(anims);

	}).then(function() {

		var anims = [];

		for(var i = 0; i < jokers.length; i++) {
			var fade = new AnimFade("out", jokers[i], 300, 100);
			anims.push(fade.run());
		}

		return Promise.all(anims);

	}).then(function() {


		for(var i = 0; i < jokers.length; i++) {
			madnes_sprite_set_frame_name(jokers[i], picture_convert[win_set['symbol']]);

//			madnes_set_texture(jokers[i], picture_convert[win_set['symbol']]);
			madnes_set_alpha(jokers[i], 1);
            madnes_set_scale(jokers[i], 1, 1);
			madnes_set_visible(jokers[i], true);
		}

	}).then(function() {

		var anims = [];

        for(var i = 0; i < symbNames.length; i++) {
            var pulse = new AnimPulse(symbNames[i], 1.12, 1.12, 300, 0);
            anims.push(pulse.run());
        }

        audio_play_win_line(win_set);

		return Promise.all(anims);

	}).then(function() {

		return new Promise(function(res) {
			var blink = new AnimBlink(symbNames, 2, 1000);
			blink.run().then(res);
		});

	}).then(function() {

		return new Promise(function(res) {
			setTimeout(res, 100);
		});

	}).then(function() {

		if(typeof win_set['line'] != 'undefined') {
			hide_winline(win_set['line']);
			hide_all_win_dots();
		}

//		for(var pos in win_set.position) {
////			var xPos = win_set.position[pos][0];
////			var yPos = 2 - win_set.position[pos][1];
////			var symbName = "reels_bufer_" + xPos + "_S" + yPos;
////			set_symbol_center_top_left(symbName);
//
//		}

		for(var i = 0, l = jokers.length; i < l; i++) {
			madnes_sprite_set_frame_name(jokers[i], madnes_get_cstm_val(jokers[i]));
//			madnes_set_texture(jokers[i], madnes_get_cstm_val(jokers[i]));
		}

		result_control_part();
	});
}

function audio_play_win_line(winset)
{
	if(typeof picture_convert[winset['symbol']] != 'undefined') {
		var symbol = picture_convert[winset['symbol']];
		madnes_audio_play("WIN_LINE_" + symbol);
	}
}

function get_symbol_on_position(x, y)
{
	var sNum = server_result.result.reelMatrix[0][x][y];
	return picture_convert[sNum];
}

export function is_joker_in_reel(reel) {

	var jokerIndex = picture_convert.indexOf('symbol_Joker');

	if(typeof reel == 'object' && jokerIndex >= 0) {
		return reel.indexOf(jokerIndex) >= 0 ? true : false;
	}

	return false;
}


function show_all_lines()
{
	for(var i = 0; i <= 26; i++) {
		madnes_set_visible('winline_' + i, true);
	}
}

export function hide_all_lines()
{
	for(var i = 0; i <= 26; i++) {
		madnes_set_visible('winline_' + i, false);
	}
}

function show_winline(i)
{
	switch(i) {
		case 0: case 3: case 6:
			madnes_set_visible("win_dot_left_0", true);
			madnes_set_visible("win_dot_right_0", true);
			break;
		case 1: case 4: case 7:
			madnes_set_visible("win_dot_left_0", true);
			madnes_set_visible("win_dot_right_1", true);
			break;
		case 2: case 5: case 8:
			madnes_set_visible("win_dot_left_0", true);
			madnes_set_visible("win_dot_right_2", true);
			break;
		case 9: case 12: case 15:
			madnes_set_visible("win_dot_left_1", true);
			madnes_set_visible("win_dot_right_0", true);
			break;
		case 10: case 13: case 16:
			madnes_set_visible("win_dot_left_1", true);
			madnes_set_visible("win_dot_right_1", true);
			break;
		case 11: case 14: case 17:
			madnes_set_visible("win_dot_left_1", true);
			madnes_set_visible("win_dot_right_2", true);
			break;
		case 18: case 21: case 24:
			madnes_set_visible("win_dot_left_2", true);
			madnes_set_visible("win_dot_right_0", true);
			break;
		case 19: case 22: case 25:
			madnes_set_visible("win_dot_left_2", true);
			madnes_set_visible("win_dot_right_1", true);
			break;
		case 20: case 23: case 26:
			madnes_set_visible("win_dot_left_2", true);
			madnes_set_visible("win_dot_right_2", true);
			break;
	}


	madnes_set_visible('winline_' + i, true);
}

function hide_winline(i) {
	madnes_set_visible('winline_' + i, false);
}

export function hide_all_win_dots() {
	for(var i = 0; i < 3; i++) {
		madnes_set_visible("win_dot_left_" + i, false);
		madnes_set_visible("win_dot_right_" + i, false);
	}
}

function betmenu_open() {
	show_all_lines();
}